// Prominent "next game" banner for the Live tab: opponent, field, time and a
// countdown — the "move to your field now" surface during playoffs

import { useFirebase } from './FirebaseContextProvider';
import DateTimeBadge from './DateTimeBadge';
import {
  gameStartMoment,
  gameEndMoment,
  gameTypeLabel,
  fieldName,
  matchupLabel,
} from '../utils/live';
import './LiveNextGameBanner.scss';

export default function LiveNextGameBanner({ tournament, game, teamId, now }) {
  const { teamsById } = useFirebase();

  if (!game) return null;

  const start = gameStartMoment(tournament, game);
  const end = gameEndMoment(tournament, game);
  const inProgress = !start.isAfter(now) && end.isAfter(now);
  const minsToStart = start.diff(now, 'minutes');

  // Live status shown only when time-sensitive — the date/time badge already
  // carries the full when, so no "today"/full-date fallback is needed here
  let status;
  if (inProgress) {
    status = 'In progress';
  } else if (minsToStart <= 120) {
    status = `Starts in ${Math.max(minsToStart, 1)} min`;
  }

  return (
    <div
      className={`block accent live-next-game-banner${inProgress ? ' in-progress' : ''}`}
    >
      <div className='banner-top'>
        <DateTimeBadge start={start} end={end} />
        <span className='type'>{gameTypeLabel(game)}</span>
      </div>
      <h5 className='banner-matchup'>
        {matchupLabel(teamsById, game, teamId)}
      </h5>
      <div className='banner-details'>
        <span className='field'>
          <span className='fa-location gray-800' /> {fieldName(tournament, game)}
        </span>
        {status && <span className='status'>{status}</span>}
      </div>
    </div>
  );
}
